"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-radio-checked.tsx
var RadioChecked = function RadioChecked(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    id: "a-radio-button"
  }, (0, _preact.h)("circle", {
    id: "border",
    cx: "12",
    cy: "12",
    r: "7.5",
    stroke: props.stroke || '#0069FF'
  }), (0, _preact.h)("circle", {
    id: "solid",
    cx: "12",
    cy: "12",
    r: "5",
    fill: props.fill || '#0069FF'
  })));
};

var _default = RadioChecked;
exports.default = _default;